import React from 'react';
export default () =>

<svg width="190" height="190" viewBox="0 0 190 190" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M190 2.9024e-06H30.6452C13.7203 2.9024e-06 0 13.7203 0 30.6452V190L0.0191473 189.234C0.43468 172.613 14.0282 159.355 30.6547 159.355H128.71C145.635 159.355 159.355 145.635 159.355 128.71V30.6547C159.355 14.0282 172.613 0.434683 189.234 0.0191507L190 2.9024e-06Z" fill="#1CB6CC"/>
</svg>
